import { innovorderApi } from '../index';
import type { ApiRequest, ApiResponse, TokenRequest } from '../request.types';
import type { VatConfigurationCsvParams, VatConfigurationResponse } from './vatConfiguration.type';

const vatConfigurationApi = innovorderApi.injectEndpoints({
    endpoints: (build) => ({
        getVatConfiguration: build.query<VatConfigurationResponse, TokenRequest>({
            query: ({ token }) => ({
                url: `/api/v1/vat-configuration`,
                method: 'GET',
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }),
            transformResponse: (response: ApiResponse<VatConfigurationResponse>) => response.data,
            extraOptions: { maxRetries: 3 },
        }),
        getVatConfigurationCsv: build.query<string, ApiRequest<VatConfigurationCsvParams>>({
            query: ({ token, zoneCode, groupCode, mode }) => {
                const params: Record<string, string> = { format: 'csv' };
                if (zoneCode) params.zoneCode = zoneCode;
                if (groupCode) params.groupCode = groupCode;
                if (mode) params.mode = mode;

                return {
                    url: `/api/v1/vat-configuration`,
                    method: 'GET',
                    params,
                    headers: { authorization: `Bearer ${token}` },
                    responseHandler: 'text',
                };
            },
        }),
    }),
});

export const { useGetVatConfigurationQuery, useLazyGetVatConfigurationCsvQuery } = vatConfigurationApi;
